
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import TuitionPriceLinesContent from "./components/TuitionPriceLinesContent.vue";

export default defineComponent({
  name: "TuitionPriceLinesPage",
  components: {
    BreadCrumb,
    TuitionPriceLinesContent,
  },
});
